import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { setSidebarTab } from '@plone/volto/actions/sidebar/sidebar';
import View from './View';
import { HomepageContactSchema } from './schema';
import { normalizeImageRef } from '../../../helpers/homepageUtils';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const sidebarTab = useSelector((state) => state.sidebar?.tab);
  const schema = HomepageContactSchema({ intl });

  useEffect(() => {
    if (selected && sidebarTab !== 2) {
      dispatch(setSidebarTab(1));
    }
  }, [dispatch, selected, sidebarTab]);

  useEffect(() => {
    const background = data.background;
    if (
      typeof background === 'string' ||
      (background && !background['@type'])
    ) {
      onChangeBlock(block, {
        ...data,
        background: normalizeImageRef(background),
      });
    }
  }, [block, data, onChangeBlock]);

  return (
    <>
      <div
        className="homepage-contact-preview"
        role="presentation"
        onClick={() => {
          if (selected && sidebarTab !== 2) {
            dispatch(setSidebarTab(1));
          }
        }}
      >
        <View data={data} editPreview />
      </div>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default withBlockExtensions(Edit);
